export default __webpack_public_path__ + "static/media/recomend-color-icon.82f1f43f.svg";